import React, {useEffect} from "react";
import clsx from "clsx";
import {useSelector} from "react-redux";

import {
    grid,
    blur,
} from "../../styles/search.module.scss";

const PageLayout = ({children}) => {
    const isLoad = useSelector(({searchReducer}) => searchReducer.isLoad);
    const appSettings = useSelector(({rootReducer}) => rootReducer.baseSettings);
    const data = useSelector(({searchReducer}) => searchReducer.searchPostsData.data);
    const themeData = JSON.parse(appSettings.theme) || [];
    const root = document.getElementById("js-fs-search");

    useEffect(() => {
        // setNum(randomNumberInRange(0, data?.results?.length));
        // eslint-disable-next-line array-callback-return
        Object.entries(themeData).map((item, key) => {
            document.documentElement.style.setProperty(item[0], item[1]);
        });
    }, [data, themeData]);

    return (
        <>
            {
                appSettings.heroImageHtml && (
                    <div className="mus-hero" style={{
                        overflow: 'hidden',
                        height: '500px',
                        width: '100%',
                        gridTemplateRows: 'repeat(1,minmax(0,1fr))',
                        gridTemplateColumns: 'repeat(1,minmax(0,1fr))',
                        display: 'grid',
                        position: 'relative'
                    }}>
                        <figure style={{
                            position: 'relative',
                            gridColumnStart: 1,
                            gridColumnEnd: 2,
                            gridRowStart: 1,
                            gridRowEnd: 2,
                            overflow: 'hidden'
                        }}
                                dangerouslySetInnerHTML={{__html: data?.hero_image_html ? data?.hero_image_html : appSettings.heroImageHtml}}/>
                        {
                            appSettings.searchPageTitle && (
                                <div style={{
                                    display: 'flex',
                                    gridColumnStart: 1,
                                    gridColumnEnd: 2,
                                    gridRowStart: 1,
                                    gridRowEnd: 2,
                                    overflow: 'hidden',
                                    alignItems: 'center'
                                }}>
                                    <div className="container" style={{
                                        display: 'relative',
                                        zIndex: 1
                                    }}>
                                        <h1 dangerouslySetInnerHTML={{__html: appSettings.searchPageTitle}}/>
                                    </div>

                                </div>
                            )
                        }
                    </div>
                )
            }
            <div className="container">
                <div className={clsx(`fs_facet-search--grid ${grid}`, isLoad && blur)}>
                    {children}
                </div>
            </div>
        </>
    );
};
export default PageLayout;
